import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]

  connect() {
    // Initialize with open state by default
    this.open()
  }

  toggle() {
    const isExpanded = this.element.querySelector("button").getAttribute("aria-expanded") === "true"
    
    if (isExpanded) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.contentTarget.classList.remove("hidden")
    this.element.querySelector("button").setAttribute("aria-expanded", "true")
    
    // Rotate plus to minus
    this.iconTarget.innerHTML = `
      <svg class="h-5 w-5 text-ph24_new_blue" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path fill-rule="evenodd" d="M3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd" />
      </svg>
    `
  }

  close() {
    this.contentTarget.classList.add("hidden")
    this.element.querySelector("button").setAttribute("aria-expanded", "false")
    
    // Rotate minus to plus
    this.iconTarget.innerHTML = `
      <svg class="h-5 w-5 text-ph24_new_blue" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd" />
      </svg>
    `
  }
}
